import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { placesEnvironment } from '../places-environment';
import { placeSchema } from '../schemas/place.schema';

/**
 * Get place details by trimblePlaceId
 * @param placeId the trimblePlaceId of the place
 * @returns Details of the place
 */
export function getPlacePlaceId(this: unknown, placeId: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        placesEnvironment.resolve(this).placesPlacePlaceIdUrl(placeId),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(placeSchema));
}
